import { Link, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { useState, useEffect,useMemo  } from "react";
import { FaBookmark, FaRegBookmark, FaBath, FaBed, FaRupeeSign } from "react-icons/fa";

import { FaWhatsapp } from 'react-icons/fa';

import { SlSizeFullscreen } from "react-icons/sl";
import { MdRealEstateAgent } from "react-icons/md";
import { IoChatboxEllipsesOutline } from "react-icons/io5";
import { IoShareOutline } from "react-icons/io5";
import DialogProperty from "./DialogProperty";
import { useMutation, useQuery } from "@tanstack/react-query";
import { toast, Toaster } from "sonner";
import httpCommon from "../../http-common";
import starsImage from './asset_makers_stars.png';

import { queryClient } from "../..";
import "./card.scss";
const selectedRowIds = new Set();
const selectedRowData = new Map();

function PropertyCard({ item, onPropertyRemoved , index = 0  }) {
  console.log("item___",item)
  const { currentUser } = useSelector((state) => state.user);
  const [open, setOpen] = useState(false);
  const [isSaved, setIsSaved] = useState(false);
  const [tick, setTick] = useState(0); 
  const allProperties = window.__ALL_PROPERTIES__ || [];

  // console.log("item", item);

  const navigate = useNavigate();
  const defaultImage = httpCommon.defaults.baseURL + '/images/defaultasset.jpg';

 const rowId = useMemo(() => {
    return item?.RowID != null ? String(item.RowID) : "";
  }, [item?.RowID]);

  //  selection from global Set
  const isSelected = selectedRowIds.has(rowId);

  //  Toggle checkbox selection
const handleCheckboxToggle = (e) => {
  e.stopPropagation();
  if (!rowId) return;

  if (selectedRowIds.has(rowId)) {
    selectedRowIds.delete(rowId);
    selectedRowData.delete(rowId);   // remove item data
  } else {
    selectedRowIds.add(rowId);
    selectedRowData.set(rowId, item); // store full item
  }

  setTick((prev) => prev + 1);
  window.dispatchEvent(new Event("selectionChanged"));
};


  useEffect(() => {
  if (index !== 0) return;

  const refresh = () => setTick((prev) => prev + 1);

  window.addEventListener("selectionChanged", refresh);

  return () => {
    window.removeEventListener("selectionChanged", refresh);
  };
}, [index]);


  const fetchSavedProperties = async () => {
    if (!currentUser) return [];
    const res = await httpCommon.get(`/saved-list/${currentUser.id}`);
    return res.data;
  };

  const { data: savedProperties } = useQuery({
    queryKey: ["savedProperties", currentUser?.id],
    queryFn: fetchSavedProperties,
    enabled: !!currentUser,
  });

  useEffect(() => {
    if (savedProperties) {
      setIsSaved(savedProperties.some((property) => property.property_id === item.RowID));
    }
  }, [savedProperties, item.RowID]);

  const handleClose = () => {
    setOpen(false);
  };

  const sendMessage = async (data) => {
    try {
      const res = await httpCommon.post(`/contact/enquiry`, data);
      return res.data;
    } catch (error) {
      toast.error("Internal error at Sending Message");
      console.error(error);
    }
  };

  const mutation = useMutation({
    mutationFn: sendMessage,
    onSuccess: (data) => {
      toast.success(data?.message);
      queryClient.invalidateQueries({ queryKey: "messages" });
      handleClose();
    },
    onError: (error) => {
      console.log(error);
      toast.error("Internal error at Sending Message");
    },
  });

  const saveToSavedList = async () => {
    if (!currentUser) {
      navigate("/sign-in");
      return;
    }
    try {
      const res = await httpCommon.post(`/saved-list/add`, {
        userId: currentUser.id,
        propertyId: item.RowID,
      });
      toast.success(res.data.message);
      setIsSaved(true);
    } catch (error) {
      console.error(error);
      handleError(error);
    }
  };

  const removeFromSavedList = async () => {
    if (!currentUser) {
      navigate("/sign-in");
      return;
    }
    try {
      await httpCommon.delete(`/saved-list/remove`, {
        data: {
          userId: currentUser.id,
          propertyId: item.RowID,
        },
      });
      toast.success("Property removed from saved list");
      setIsSaved(false);
      if (onPropertyRemoved) {
        onPropertyRemoved();
      }
    } catch (error) {
      console.error(error);
      handleError(error);
    }
  };

  const handleError = (error) => {
    if (error.response) {
      const { status, data } = error.response;
      if (status === 400) {
        toast.error("User ID and Property ID are required");
      } else if (status === 404) {
        toast.error("Property not found in saved list");
      } else {
        toast.error(data.message || "Internal error");
      }
    } else {
      toast.error("Internal error");
    }
  };

  const getImageAttachments = (attachments) => {
    if (!attachments) {
      return [];
    }
    return attachments.filter(att => att.type === "Main");
  };

  const imageAttachments = item ? getImageAttachments(item.attachments) : [];

  const priceMapping = {
    Plots: item.ltg_det_plot_sale_price,
    Villas: item.ltg_det_sale_price,
    Apartments: item.ltg_det_sale_price,
    RowHouses: item.ltg_det_row_house_sale_price,
    CommercialProperties: item.ltg_det_comm_prop_sale_price,
    Villaments: item.ltg_det_villaments_sale_price,
    PentHouses: item.ltg_det_penthouses_sale_price,
  };

  const price = priceMapping[item.ltg_type] || item.ltg_det_sale_price;
  const { numeric: numericPrice, formatted: formattedPrice } = formatPrice(price != null ? price.toLocaleString('en-IN') : '0');

  const suffixPriceMapping = {
    Plots: item?.ltg_det_plot_suffix_price,
    Villas: item?.ltg_det_suffix_price,
    Apartments: item?.ltg_det_suffix_price,
    RowHouses: item?.ltg_det_row_house_suffix_price,
    CommercialProperties: item?.ltg_det_comm_prop_suffix_price,
    Villaments: item?.ltg_det_villaments_suffix_price,
    PentHouses: item?.ltg_det_penthouses_suffix_price,
  };

  const suffixPrice = suffixPriceMapping[item?.ltg_type] || item?.ltg_det_suffix_price;
  const { numeric: numericSuffixPrice, formatted: formattedSuffixPrice } = formatPrice(suffixPrice != null ? suffixPrice.toLocaleString('en-IN') : '0');


  const bedroomMapping = {
    Plots: item.ltg_det_pmts_bed_rom,
    Villas: item.ltg_det_pmts_bed_rom,
    Apartments: item.ltg_det_pmts_bed_rom,
    RowHouses: item.ltg_det_row_house_pmts_bed_rooms,
    Villaments: item.ltg_det_villaments_pmts_bed_rooms,
    PentHouses: item.ltg_det_penthouses_pmts_bed_rooms,
  };

  const bedrooms = bedroomMapping[item.ltg_type] || item.ltg_det_pmts_bed_rom;

  const bathroomMapping = {
    Plots: item.ltg_det_pmts_bth_rom,
    Villas: item.ltg_det_pmts_bth_rom,
    Apartments: item.ltg_det_pmts_bth_rom,
    RowHouses: item.ltg_det_row_house_pmts_bath_rooms,
    Villaments: item.ltg_det_villaments_pmts_bath_rooms,
    PentHouses: item.ltg_det_penthouses_pmts_bath_rooms,
  };

  const bathrooms = bathroomMapping[item.ltg_type] || item.ltg_det_pmts_bth_rom;

  const addressMapping = {
    Plots: item?.ltg_det_plot_address,
    Villas: item?.ltg_det_address,
    Apartments: item?.ltg_det_address,
    RowHouses: item?.ltg_det_row_house_address,
    Villaments: item?.ltg_det_villaments_address,
    PentHouses: item?.ltg_det_penthouses_address,
    CommercialProperties: item?.ltg_det_comm_prop_address,
  };

  const address = item ? addressMapping[item.ltg_type] || item.ltg_det_address : "Address not available";

  const areaMapping = {
    Plots: item?.ltg_det_plot_pmts_area_dts,
    Villas: item?.ltg_det_pmts_area_dts,
    Apartments: item?.ltg_det_pmts_area_dts,
    RowHouses: item?.ltg_det_row_house_pmts_area_dts,
    Villaments: item?.ltg_det_villaments_pmts_area_dts,
    PentHouses: item?.ltg_det_penthouses_pmts_area_dts,
    CommercialProperties: item?.ltg_det_comm_prop_pmts_area_dts,
  };

  const area = item ? areaMapping[item.ltg_type] || item.ltg_det_pmts_area_dts : "Area not available";

  const statusMapping = {
    Plots: item?.ltg_det_plot_pmts_status,
    Villas: item?.ltg_det_pmts_status,
    Apartments: item?.ltg_det_pmts_status,
    RowHouses: item?.ltg_det_row_house_pmts_status,
    Villaments: item?.ltg_det_villaments_pmts_status,
    PentHouses: item?.ltg_det_penthouses_pmts_status,
    CommercialProperties: item?.ltg_det_comm_prop_pmts_status,
  };

  const status = item ? statusMapping[item.ltg_type] || item.ltg_det_pmts_status : "Status not available";

  const callForPriceMapping = {
    Plots: item?.ltg_det_plot_call_for_price,
    Villas: item?.ltg_det_call_for_price,
    Apartments: item?.ltg_det_call_for_price,
    RowHouses: item?.ltg_det_row_house_call_for_price,
    CommercialProperties: item?.ltg_det_comm_prop_call_for_price,
    Villaments: item?.ltg_det_villaments_call_for_price,
    PentHouses: item?.ltg_det_penthouses_call_for_price,
  };

  const callForPrice = callForPriceMapping[item?.ltg_type] || item?.ltg_det_call_for_price;

  // Function to format the title

  const formatTitleForUrl = (title) => {
    if (!title) return "untitled";
    return title
      .toLowerCase()
      .trim();
  };

  function formatPrice(price, onlyFormatted = false) {
    if (price == null) {
      return onlyFormatted ? "N/A" : { numeric: 0, formatted: "N/A" };
    }

    const numericPrice = parseFloat(price.replace(/,/g, ""));
    if (isNaN(numericPrice)) {
      return onlyFormatted ? "N/A" : { numeric: 0, formatted: "N/A" };
    }

    let formatted;
    if (numericPrice < 1000) {
      formatted = numericPrice.toString();
    } else if (numericPrice < 100000) {
      formatted = `${(numericPrice / 1000).toFixed(0)} Thousand`;
    } else if (numericPrice < 10000000) {
      const lakhs = numericPrice / 100000;
      formatted = lakhs % 1 === 0 ? `${lakhs.toFixed(0)} Lakhs` : `${lakhs.toFixed(1)} Lakhs`;
    } else {
      const crores = numericPrice / 10000000;
      formatted = crores % 1 === 0 ? `${crores.toFixed(0)} Cr` : `${crores.toFixed(2)} Cr`;
    }
    return onlyFormatted ? formatted : { numeric: numericPrice, formatted };
  }

// Handle card click to navigate

const handleCardClick = (e) => {
  if (e.target.closest("input[type='checkbox']")) return;

  const url = `/Property/${
    item?.propertyUrl ? formatTitleForUrl(item.propertyUrl) : "untitled"
  }`;

   window.open(url, "_blank", "noopener,noreferrer");
  
};

  const parsePriceSafe = (value) => {
  if (value == null) return 0;

  // if already number
  if (typeof value === "number") return value;

  // convert string like "₹ 45,00,000" → 4500000
  const num = Number(String(value).replace(/[^\d.]/g, ""));
  return isNaN(num) ? 0 : num;
};

const formatPrice2 = (num) => {
  const value = parsePriceSafe(num);

  if (!value) return "Price not available";

  if (value >= 10000000) return (value / 10000000).toFixed(2) + " Cr";
  if (value >= 100000) return (value / 100000).toFixed(2) + " Lakh";
  if (value >= 1000) return (value / 1000).toFixed(2) + " Thousand";
  return value.toFixed(0);
};

const safeEncode = (text) =>
  encodeURIComponent(text).replace(/%0A/g, "%0D%0A");

const handleShareWhatsApp = () => {
  const selectedItems = Array.from(selectedRowData.values());

  if (selectedItems.length === 0) {
    toast.error("Please select at least one property");
    return;
  }

  let message = "🏡 *Check out these properties:*\n\n";

  selectedItems.forEach((x, i) => {
    const projectName = x.ltg_projectName || "Project Name";
    const title = x.ltg_title || "Title";

    const rawPrice =
      x.ltg_det_plot_sale_price ||
      x.ltg_det_sale_price ||
      x.ltg_det_call_for_price;

    const priceText =
      String(rawPrice).toLowerCase().includes("call")
        ? "Call for Price"
        : formatPrice2(rawPrice);

    const location =
      x.ltg_det_plot_location ||
      x.ltg_det_location ||
      "Location not available";

    const cleanedPath = x.propertyUrl?.startsWith("/")
      ? x.propertyUrl.slice(1)
      : x.propertyUrl;

    const url = cleanedPath
      ? `${window.location.origin}/Property/${cleanedPath}`
      : window.location.href;

    message += `*${i + 1}. ${projectName}*\n`;
    message += `${title}\n`;
    message += `💰 Price: ${priceText}\n`;
    message += `📍 Location: ${location}\n`;
    message += `🔗 Link: ${url}\n\n`;
  });

 // const whatsappUrl = `https://wa.me/?text=${encodeURIComponent(message)}`;
   const whatsappUrl = `https://api.whatsapp.com/send?text=${safeEncode(message)}`;
  window.open(whatsappUrl, "_blank");
};

  // Handle checkbox toggle
const ratePerSqFtMap = {
  Plots: item?.ltg_det_plot_pmts_rate_per_sq,
  Villas: item?.ltg_det_pmts_rate_per_sq,
  RowHouses: item?.ltg_det_row_house_pmts_rate_per_sq,
  Villaments: item?.ltg_det_villaments_pmts_rate_per_sq,
  CommercialProperties: item?.ltg_det_comm_prop_pmts_rate_per_sq,
  PentHouses: item?.ltg_det_penthouses_pmts_rate_per_sq,
  Apartments: item?.ltg_det_pmts_rate_per_sq,
};

const ratePerSqFt =
  ratePerSqFtMap[item?.ltg_type] ?? item?.ltg_det_pmts_rate_per_sq;

console.log("item____1111",item);
  return (
    <>
      <Toaster richColors />
      <DialogProperty
        open={open}
        setOpen={setOpen}
        item={item}
        handleClose={handleClose}
        mutation={mutation}
      />
    <div
        className={`cardProperty ${Number(item?.ltg_det_sold_type || 0) === 1 ? "sold-out" : ""}`}
        style={{ display: "flex", position: "relative", cursor: "pointer" }}
        onClick={handleCardClick}
      >
        <div className="cardImageContainer">
          {imageAttachments.length > 0 ? (
            <img
              src={
                imageAttachments[0].attachment
                  ? httpCommon.defaults.baseURL + imageAttachments[0].attachment
                  : defaultImage
              }
              alt="attachment"
            />
          ) : (
            <img src={defaultImage} alt="default attachment" />
          )}
        </div>
        <div className="cardTextContainer" style={{ flex: 1, position: "relative" }}>
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
            {item.ltg_projectName && (
              <h3 className="cardProjectName">{item.ltg_projectName}</h3>
            )}

          {index === 0 && selectedRowIds.size > 0 && (
            <div
              style={{
                position: "fixed",
                bottom: "30px",
                right: "25px",
                zIndex: 99999,
              }}
            >
              <button
                onClick={(e) => {
                  e.stopPropagation();
                  handleShareWhatsApp();
                }}
                title={`Share ${selectedRowIds.size} selected properties`}
                style={{
                  width: "45px",
                  height: "45px",
                  borderRadius: "50%",
                  border: "2px solid #25D366", // ✅ WhatsApp border
                  cursor: "pointer",

                  background: "#ffffff", // ✅ white clean background
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",

                  // ✅ softer shadow (NO black circle effect)
                  boxShadow: "0px 1px 2px rgba(0,0,0,0.18)",
                  transition: "all 0.25s ease",
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = "scale(1.07)";
                  e.currentTarget.style.boxShadow = "0px 6px 18px rgba(0,0,0,0.22)";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = "scale(1)";
                  e.currentTarget.style.boxShadow = "0px 4px 12px rgba(0,0,0,0.18)";
                }}
              >
                <FaWhatsapp size={28} color="#25D366" />
              </button>

              {/* ✅ Badge */}
              <span
                style={{
                  position: "absolute",
                  top: "-6px",
                  right: "-6px",

                  background: "#25D366",
                  color: "white",
                  fontWeight: "700",
                  fontSize: "12px",

                  minWidth: "22px",
                  height: "22px",
                  padding: "0px 6px",
                  borderRadius: "50px",

                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",

                  border: "2px solid white",
                  boxShadow: "0px 2px 3px rgba(0,0,0,0.2)",
                }}
              >
                {selectedRowIds.size}
              </span>
            </div>
          )}

            {/* CHECKBOX - Properly isolated from card click */}
           <div 
                style={{ 
                  display: "flex", 
                  alignItems: "center", 
                  gap: "8px",
                  padding: "8px 12px",
                  
                  backgroundColor: isSelected ? "#e0f2fe" : "#f8fafc",
                  borderRadius: "6px",
                  border: isSelected ? "2px solid #0ea5e9" : "2px solid #e2e8f0",
                  cursor: "pointer",
                  transition: "all 0.2s"
                }}
                onMouseDown={(e) => e.stopPropagation()}
                onClick={(e) => e.stopPropagation()}
              >
                <input
                  type="checkbox"
                   checked={isSelected}
                  onMouseDown={(e) => e.stopPropagation()}
                  onClick={(e) => e.stopPropagation()}  // ✅ stop card click
                  onChange={handleCheckboxToggle}
                  style={{ 
                    cursor: "pointer",
                    width: "18px",
                    height: "18px",
                    accentColor: "#0ea5e9"
                  }}
                />
                <span style={{ 
                  fontSize: "14px", 
                  fontWeight: "500",
                  color: isSelected ? "#0369a1" : "#64748b",
                  userSelect: "none"
                }}>
                  {isSelected ? "Selected" : "Select"}
                </span>
              </div>
            </div>

          <h2 className="cardTitle">{item.ltg_title}</h2>

          {Number(item?.ltg_det_sold_type || 0) === 1 && (
            <div className="sold-status" style={{
              position: "absolute",
              top: "10px",
              right: "20px",
              zIndex: 10,
            }}>
              <img src={starsImage} alt="Sold Out" style={{ width: "10%", float: "right" }} />
            </div>
          )}

          <p className="cardAddress">
            <img src="/pin.png" alt="" />
            <span>{address}</span>
          </p>

          {/* <div className="card-pricing">
            {callForPrice ? (
              <span className="call-for-price">{callForPrice}</span>
            ) : (
              <>
                <span className="current-price">₹ {formattedPrice}</span>
                {numericSuffixPrice > 0 && (
                  <span
                    className="suffix-price"
                    style={{
                      textDecoration: 'line-through',
                      color: 'red',
                      marginLeft: '10px',
                    }}
                  >
                    ₹ {formattedSuffixPrice}
                  </span>
                )}
              </>
            )}
          </div> */}

          <div className="card-pricing">
          {callForPrice ? (
            <span className="call-for-price">{callForPrice}</span>
          ) : (
            <>
              <span className="current-price">₹ {formattedPrice}</span>

              {numericSuffixPrice > 0 && (
                <span
                  className="suffix-price"
                  style={{
                    textDecoration: 'line-through',
                    color: 'red',
                    marginLeft: '10px',
                  }}
                >
                  ₹ {formattedSuffixPrice}
                </span>
              )}

              {/* Rate Per Sq Ft */}
              {ratePerSqFt && (
                <span
                  className="rate-per-sqft"
                  style={{
                    display: 'inline-block',
                    marginTop: '7px',
                    padding: '4px 10px',
                    fontSize: '12px',
                    fontWeight: '600',
                    color: '#047857',
                    backgroundColor: '#ecfdf5',
                    border: '1px solid #a7f3d0',
                    borderRadius: '6px',
                    lineHeight: '1.4',
                  }}
                >
                  ₹ {ratePerSqFt} / sq. ft.
                </span>
              )}
            </>
          )}
        </div>

          <div className="bottom">
            <div className="features">
              {item.ltg_type === "Plots" || item.ltg_type === "CommercialProperties" ? (
                <span></span>
              ) : (
                <>
                  <div className="feature">
                    <FaBed />
                    <span>{bedrooms} bedroom</span>
                  </div>
                  <div className="feature">
                    <FaBath />
                    <span>{bathrooms} bathrooms</span>
                  </div>
                </>
              )}
              <div className="feature">
                <SlSizeFullscreen />
                <span>{area}</span>
              </div>
              <div className="feature">
                <MdRealEstateAgent />
                <span>{status}</span>
              </div>
            </div>
            
            <div className="icons">
              <div
                className="icon"
                onClick={(e) => {
                  e.stopPropagation();
                  isSaved ? removeFromSavedList() : saveToSavedList();
                }}
              >
                {isSaved ? <FaBookmark /> : <FaRegBookmark />}
              </div>
              <div
                className="icon"
                onClick={(e) => {
                  e.stopPropagation();
                  setOpen(true);
                }}
              >
                <IoChatboxEllipsesOutline />
              </div>
            </div>
          </div>
        </div>
      
      </div>
     

    </>
  );
}

export default PropertyCard;